<template>
	<div>
		<section class="product_details_under_shadow"></section>

		<div id="package_details" class="product_details">
			<mega-image
				@cleverBackToList="cleverBackToList"
				:productType="'package'"
				:megaImage="megaImage"
				v-if="!getOrderLoading"
			/>

			<loader class="fullpage" v-if="getOrderLoading" />

			<transition mode="out-in" name="fade" appear v-if="!getOrderLoading">
				<keep-alive>
					<router-view
						name="detail_column"
						:totalGuestInActivity="activeProductDetails.Participants"
						:details="details"
						@updateConfirmLeave="updateConfirmLeave"
						@cleverBackToList="cleverBackToList"
					></router-view>
				</keep-alive>
			</transition>

			<modal
				:modal="preModal"
				v-if="
					!modify &&
						activeProductDetails.Activities[0].PreBookMessage &&
						activeProductDetails.hasReadPreBookMessage != true
				"
			>
				<div
					class="ml-2 mr-2 mt-2 mb-2"
					v-for="act in activeProductDetails.Activities"
					:key="'package-details-activities-' + act.EntityHierarchyKey"
				>
					<h4 class="mt-4">{{ act.Name }}</h4>
					<div v-html="act.PreBookMessage"></div>
				</div>
				<template v-slot:footer>
					<a @click.prevent="cleverBackToList" href class="button outline"
						>Cancel</a
					>
					<a @click.prevent="closePreModal" href class="button blue ml-1 focus"
						>Continue</a
					>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

	import MegaImage from '../../components/MegaImage.vue';
	import Loader from '../../components/Loader.vue';

	import confirmExitAndRevertOrder from '../../mixins/confirmExitAndRevertOrder.js';

	export default {
		name: 'PackageDetails',

		components: {
			MegaImage,
			Loader,
		},

		mounted() {
			if (typeof window.OnViewProductDetails != 'undefined') {
				// console.log("window.OnViewProductDetails()");
				window.OnViewProductDetails(
					this.$store.getters.simpleOrder,
					this.activeProductDetails
				);
			}
		},

		mixins: [confirmExitAndRevertOrder],

		data: function() {
			return {
				prevRoute: null,
				scrollPos: {},
				preModal: {
					show: true,
					hideHeader: true,
				},
			};
		},

		watch: {
			'activeProductDetails.Name': {
				handler(newVal) {
					document.title = newVal;
				},
				immediate: true,
				//deep: true
			},
			'$route.params.id': {
				handler(newVal, oldVal) {
					if (newVal != oldVal) {
						this.getDetails({
							client: this.$route.params.client,
							id: this.$route.params.id,
							productType: 'package', //this.$route.params.productType,
							modify: this.$route.params.modify == 'modify' ? true : false,
						});
					}
				},
				immediate: true,
				deep: true,
			},
		},

		computed: {
			...mapState(['getOrderLoading', 'order']),
			...mapGetters(['activeProductDetails', 'logoLight']),

			megaImage() {
				if (this.activeProductDetails.PhotoVersion) {
					return (
						this.activeProductDetails.PhotoDomain +
						'w_1240,h_1240,c_fill,f_auto,q_auto' +
						'/v' +
						this.activeProductDetails.PhotoVersion +
						this.activeProductDetails.PhotoFolder +
						'/original'
					);
				}
				return false;
			},

			totalGuestInPackage() {
				//return typeof this.details.TotalGuestInPackage;
				return this.details.TotalGuestInPackage
					? this.details.TotalGuestInPackage
					: 0;
			},
			modify() {
				return this.$route.params.modify == 'modify' ? true : false;
			},
			details() {
				return this.activeProductDetails;
			},
		},

		beforeDestroy() {
			this.$store.commit('revertClient', {});
		},

		beforeRouteUpdate(to, from, next) {
			// records the previous route
			next((vm) => {
				vm.prevRoute = from;
			});
		},

		methods: {
			...mapActions(['getDetails']),
			...mapMutations(['preBookRead']),

			cleverBackToList() {
				if (this.modify) {
					this.$router.push({
						path:
							'/' + this.$route.params.client + '/cart/' + this.order.OrderKey,
					});
				}
				//
				else if (
					this.prevRoute &&
					this.prevRoute.fullPath ==
						'/' + this.$route.params.client + '/package'
				) {
					// console.log("this.$router.go(-1);");
					this.$router.go(-1);
				}
				//
				else {
					this.$router.push({
						path: '/' + this.$route.params.client + '/package',
					});
				}
			},

			closePreModal() {
				this.preModal.show = false;
				//this.preBookRead(this.activeProductDetails);
			},
		},
	};
</script>

<style></style>
